import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AppShell } from "@/components/AppShell";
import { ProfileWizard } from "@/components/ProfileWizard";
import api, { apiErrorMessage } from "@/lib/api";

export default function ProfileEdit() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(undefined);

  useEffect(() => {
    api.get("/profile").then(({ data }) => setProfile(data || {}));
  }, []);

  const save = async (data) => {
    try {
      await api.put("/profile", data);
      toast.success("Profile updated.");
      navigate("/profile");
    } catch (e) {
      toast.error(apiErrorMessage(e));
    }
  };

  return (
    <AppShell active="profile" title="Edit profile" showBack>
      {profile !== undefined && (
        <ProfileWizard initial={profile} onComplete={save} submitLabel="Save changes" />
      )}
    </AppShell>
  );
}
